import React from 'react';
import { auth } from '../firebaseConfig';
import { signOut } from 'firebase/auth';
import { Link, useNavigate } from 'react-router-dom';
import { deleteLocalStorage } from '../utils/functions';
import moment from 'moment';
import 'moment/locale/sv';
import importIcon from './../images/arrow-up-line.svg';
import exportIcon from './../images/arrow-down-line.svg';
import logoutIcon from './../images/logout-line.svg';

import { useTranslation } from '../i18n';
import ExportCSV from '../components/ExportCSV';
import UploadCSV from '../components/UploadCSV';
import ChangeBookmark from '../components/ChangeBookmark';
import ChangeLanguage from '../components/ChangeLanguage';
import DeleteAccount from '../components/DeleteAccount';
import ChangeTheme from '../components/ChangeTheme';
import Feedback from '../components/Feedback';
import ChangeWeekstart from '../components/ChangeWeekstart';
import ChangePassword from '../components/ChangePassword';
import Donate from '../components/Donate';
import InstallPWA from '../components/InstallPWA';

const UserAccount = ({
  user,
  setUser,
  userData,
  books,
  fetchBooks,
  showNotification,
  fetchUserData,
  theme,
  handleThemeChange,
  updateCurrentlyReading,
}) => {
  const lang = localStorage.getItem('language');
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleLogout = () => {
    deleteLocalStorage();
    signOut(auth)
      .then(() => {
        navigate('/');
        setUser('');
      })
      .catch((error) => {
        console.error('Navbar error:', error);
      });
  };

  return (
    <div className="container">
      {user && (
        <main>
          <div className="section">
            {userData?.name && (
              <div className="heading-wrapper">
                <h2>
                  {t.hello}, {userData.name}
                </h2>
              </div>
            )}

            {userData?.createdAt && (
              <div className="pt-65">
                {t.membersince}{' '}
                {moment(userData.createdAt.toDate())
                  .locale(lang)
                  .format('D MMM, YYYY')}
              </div>
            )}

            <div className="card">
              <h3 className="fs-m pt-65">{t.usersettings}</h3>
              <ChangeLanguage />
              <ChangeWeekstart />
              <ChangeTheme
                theme={theme}
                handleThemeChange={handleThemeChange}
              />
              <ChangeBookmark
                userData={userData}
                fetchUserData={fetchUserData}
              />

              <InstallPWA />

              <div className="separator"></div>
              <h3 className="fs-m pt-65">{t.userimportexport}</h3>

              <div className="row-item">
                <img height={24} width={24} alt="Import" src={importIcon} />
                <div className="link">
                  <UploadCSV
                    user={user}
                    books={books}
                    fetchBooks={fetchBooks}
                    showNotification={showNotification}
                  />
                </div>
              </div>

              <div className="row-item">
                <img height={24} width={24} alt="Export" src={exportIcon} />
                <ExportCSV user={user} books={books} />
              </div>

              <div className="separator"></div>
              <h3 className="fs-m pt-65">{t.userfeedback}</h3>

              <Feedback />
              <Donate />

              <div className="separator"></div>
              <h3 className="fs-m pt-65">{t.usermanagement}</h3>

              {!userData?.guest && (
                <ChangePassword showNotification={showNotification} />
              )}

              {!userData?.guest && (
                <DeleteAccount
                  userData={userData}
                  fetchBooks={fetchBooks}
                  showNotification={showNotification}
                  updateCurrentlyReading={updateCurrentlyReading}
                />
              )}

              <div className="row-item">
                <img height={24} width={24} alt="Logout" src={logoutIcon} />
                <Link className="link" to="/" onClick={handleLogout}>
                  {t.logout}
                </Link>
              </div>
            </div>
          </div>
        </main>
      )}
    </div>
  );
};

export default UserAccount;
